export default function (accumulator: number, currentValue: number | string) {
  return accumulator + +currentValue;
}
